(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alp-abandoned-checkout-popup"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
    let cookie = document.cookie;
    if (cookie.includes('alp_abandoned_checkout_triggered=true')) {
      popupOpen();
      document.cookie = 'alp_abandoned_checkout_triggered=false; path=/; max-age=0';
    }

    let triggerButtons = document.querySelectorAll(`[type="submit"]#checkout, .alp-payment-button-wrapper`);
    triggerButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        document.cookie = 'alp_abandoned_checkout_triggered=true; path=/; max-age=86400';
      });
    });

    function globoPopupButtonControl(globoElement) {
      let interval = setInterval(() => {
        let button = globoElement.querySelector('.gfb__footer.wizard__footer button[data-next-text]');
        let buttonText = button.textContent;
        if (buttonText.includes('Submit')) {
          globoElement.classList.add('is-last-step');
        } else {
          globoElement.classList.remove('is-last-step');
        }
      }, 400);

      let closeButton = globoElement.querySelectorAll('.header.dismiss , .overlay');
      closeButton.forEach(function (button) {
        button.addEventListener('click', function () {
          clearInterval(interval);
          if (globoElement.classList.contains('is-last-step')) {
            globoElement.querySelector('.gfb__footer.wizard__footer button[data-next-text]').click();
          }
        });
      });
    }

    function popupOpen() {
      let popupId = document.querySelector('.alp-abandoned-checkout-popup[data-id]').getAttribute('data-id');
      let delay = document.querySelector('.alp-abandoned-checkout-popup[data-delay]').getAttribute('data-delay');
      delay = parseInt(delay);
      if (popupId) {
        setTimeout(function () {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', popupId]);
          console.log('Abandoned checkout popup opened');
        }, delay);
      }
      //
      let globoElement = document.querySelector('.globo-formbuilder-popup');
      if (globoElement) {
        globoElement.querySelector('.globo-form .floating-button').click();
        // globoPopupButtonControl(globoElement);
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-article-custom-faqs-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const faqsItemList = document.querySelectorAll('.alp-article-custom-faqs-item-list-item');
    faqsItemList.forEach((item) => {
      item.querySelector('.alp-article-custom-faqs-item-list-item-title').addEventListener('click', function () {
        item.classList.toggle('active');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-cart-discount-info-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('discount-info-cards')) {
    class DiscountInfoCards extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.cartRoot = this.closest('[data-ajax-cart]');
        this.cartItemsRoot = this.cartRoot?.querySelector('.alp-cart-items-wrapper');
        this.onCartMutation = this.onCartMutation.bind(this);
        this.onCartSummaryUpdate = this.onCartSummaryUpdate.bind(this);

        if (this.cartItemsRoot) {
          this.cartObserver = new MutationObserver(this.onCartMutation);
          this.cartObserver.observe(this.cartItemsRoot, { childList: true, subtree: true });
        }
        window.addEventListener('alp:cart-summary-updated', this.onCartSummaryUpdate);
      }

      disconnectedCallback() {
        this.cartObserver?.disconnect();
        window.removeEventListener('alp:cart-summary-updated', this.onCartSummaryUpdate);
        window.clearTimeout(this.refreshTimer);
      }

      onCartMutation() {
        window.clearTimeout(this.refreshTimer);
        this.refreshTimer = window.setTimeout(() => this.refresh(), 0);
      }

      onCartSummaryUpdate() {
        this.refresh();
      }

      async refresh() {
        if (this.refreshPromise) {
          this.refreshQueued = true;
          return this.refreshPromise;
        }

        this.refreshPromise = this.fetchUpdatedCards()
          .catch(() => {})
          .finally(() => {
            this.refreshPromise = null;
            if (this.refreshQueued) {
              this.refreshQueued = false;
              this.refresh();
            }
          });
        return this.refreshPromise;
      }

      async fetchUpdatedCards() {
        const sectionId = this.cartRoot?.dataset.section;
        if (!sectionId) return;

        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        const response = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!response.ok) return;

        const responseHtml = await response.text();
        const responseDoc = new DOMParser().parseFromString(responseHtml, 'text/html');
        const source = responseDoc.querySelector('discount-info-cards');
        if (!source) return;

        this.className = source.className;
        this.style.cssText = source.style.cssText;
        this.innerHTML = source.innerHTML;
      }
    }

    customElements.define('discount-info-cards', DiscountInfoCards);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-cart-quantity-gift"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-quantity-gift')) {
    class CartQuantityGift extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.promotionId = this.dataset.promotionId;
        this.requiredQuantity = Number.parseInt(this.dataset.requiredQuantity, 10) || 1;
        this.triggerTag = this.dataset.triggerTag?.trim();
        this.giftVariantIds = new Set((this.dataset.giftVariantIds || '').split(',').filter(Boolean));
        this.giftProperty = '_alp_quantity_gift';
        this.storageKey = `alp-cart-quantity-gift:${this.promotionId}`;
        this.syncPromise = null;
        this.syncQueued = false;
        this.selectedVariantId = this.getSavedSelection();

        this.onCartMutations = this.onCartMutations.bind(this);
        this.onChoiceClick = this.onChoiceClick.bind(this);

        this.cartRoot = this.closest('[data-ajax-cart]');
        this.cartItemsRoot = this.cartRoot?.querySelector('.alp-cart-items-wrapper');
        if (this.cartItemsRoot) {
          this.cartObserver = new MutationObserver(this.onCartMutations);
          this.cartObserver.observe(this.cartItemsRoot, { childList: true, subtree: true });
        }
        this.addEventListener('click', this.onChoiceClick);
        this.sync();
      }

      disconnectedCallback() {
        this.cartObserver?.disconnect();
        window.clearTimeout(this.mutationTimer);
        this.removeEventListener('click', this.onChoiceClick);
      }

      onCartMutations() {
        window.clearTimeout(this.mutationTimer);
        this.mutationTimer = window.setTimeout(() => this.sync(), 0);
      }

      onChoiceClick(event) {
        const choice = event.target.closest('[data-gift-choice]');
        if (!choice || !this.contains(choice) || this.dataset.busy === 'true') return;

        this.selectedVariantId = choice.dataset.giftVariantId;
        this.saveSelection(this.selectedVariantId);
        this.updateSelectedChoice();
        this.sync();
      }

      async sync() {
        if (this.syncPromise) {
          this.syncQueued = true;
          return this.syncPromise;
        }

        this.syncPromise = this.fetchCart()
          .then((cart) => this.applyCart(cart))
          .catch(() => {})
          .finally(() => {
            this.syncPromise = null;
            if (this.syncQueued) {
              this.syncQueued = false;
              this.sync();
            }
          });

        return this.syncPromise;
      }

      async fetchCart() {
        const response = await fetch(`${this.dataset.cartUrl}.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      }

      async applyCart(cart) {
        const triggerQuantity = this.getMatchingQuantity();
        const isUnlocked = triggerQuantity >= this.requiredQuantity;

        this.hidden = false;
        this.classList.remove('hidden');
        this.classList.toggle('is-unlocked', isUnlocked);
        this.updateProgress(triggerQuantity);
        this.updateUnlockedContent(isUnlocked, triggerQuantity);

        const giftLines = cart.items.filter((item) => {
          return item.properties?.[this.giftProperty] === this.promotionId;
        });

        const savedOrExistingSelection = giftLines.find((item) => this.giftVariantIds.has(String(item.variant_id)));
        if (!this.selectedVariantId && savedOrExistingSelection) {
          this.selectedVariantId = String(savedOrExistingSelection.variant_id);
        }
        this.selectedVariantId ||= this.querySelector('[data-gift-choice]')?.dataset.giftVariantId;
        this.updateSelectedChoice();

        let updatedCart = null;
        let giftWasUpdated = false;

        if (!isUnlocked) {
          if (giftLines.length) {
            updatedCart = await this.removeGiftLines(giftLines);
            giftWasUpdated = true;
          }
          if (giftWasUpdated) await this.refreshGiftCartSummary(updatedCart?.item_count);
          return;
        }

        const selectedGiftLine = giftLines.find((item) => String(item.variant_id) === this.selectedVariantId);
        const extraGiftLines = giftLines.filter((item) => item !== selectedGiftLine);

        if (extraGiftLines.length) {
          updatedCart = await this.removeGiftLines(extraGiftLines);
          giftWasUpdated = true;
        }
        if (!selectedGiftLine && this.selectedVariantId) {
          await this.addGift(this.selectedVariantId);
          updatedCart = { item_count: (updatedCart?.item_count ?? cart.item_count) + 1 };
          giftWasUpdated = true;
        }
        if (giftWasUpdated) await this.refreshGiftCartSummary(updatedCart?.item_count);
      }

      updateProgress(triggerQuantity) {
        const completedQuantity = Math.min(triggerQuantity, this.requiredQuantity);
        const progress = Math.min(100, (triggerQuantity / this.requiredQuantity) * 100);
        const progressEl = this.querySelector('[data-gift-progress]');
        const fillEl = this.querySelector('[data-gift-progress-fill]');
        if (progressEl) progressEl.setAttribute('aria-valuenow', String(completedQuantity));
        if (fillEl) fillEl.style.width = `${progress}%`;
      }

      getMatchingQuantity() {
        const cartRoot = this.closest('[data-ajax-cart]');
        if (!cartRoot || !this.triggerTag) return 0;

        return [...cartRoot.querySelectorAll('.alp-cart-line-item[data-line-tags]')].reduce((total, lineItem) => {
          const tags = (lineItem.dataset.lineTags || '')
            .split(',')
            .map((tag) => tag.trim())
            .filter(Boolean);
          const quantity = Number.parseInt(lineItem.dataset.lineQuantity, 10) || 0;
          return tags.includes(this.triggerTag) ? total + quantity : total;
        }, 0);
      }

      updateUnlockedContent(isUnlocked, triggerQuantity) {
        const lockedText = this.querySelector('[data-gift-locked-text]');
        const noTriggerText = this.querySelector('[data-gift-no-trigger-text]');
        const unlockedText = this.querySelector('[data-gift-unlocked-text]');
        const lockedTextTemplate = this.querySelector('[data-gift-locked-text-template]');
        const products = this.querySelector('[data-gift-products]');
        if (noTriggerText) noTriggerText.hidden = triggerQuantity > 0;
        if (lockedText) {
          lockedText.hidden = triggerQuantity === 0 || isUnlocked;
          if (lockedTextTemplate) {
            lockedText.innerHTML = lockedTextTemplate.innerHTML.replace(/\[number\]/g, String(triggerQuantity));
          }
        }
        if (unlockedText) unlockedText.hidden = !isUnlocked;
        if (products) products.hidden = !isUnlocked;
      }

      updateSelectedChoice() {
        this.querySelectorAll('[data-gift-choice]').forEach((choice) => {
          const isSelected = choice.dataset.giftVariantId === this.selectedVariantId;
          choice.classList.toggle('is-selected', isSelected);
          choice.setAttribute('aria-pressed', String(isSelected));
        });
      }

      async refreshGiftCartSummary(itemCount) {
        await Promise.all([this.refreshCartTotal(), this.updateCartCount(itemCount)]);
        window.dispatchEvent(new CustomEvent('alp:cart-summary-updated'));
      }

      async refreshCartTotal() {
        const sectionId = this.cartRoot?.dataset.section;
        const totalTarget = this.cartRoot?.querySelector('.alp-cart-total');
        if (!sectionId || !totalTarget) return;

        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        const response = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!response.ok) return;

        const responseHtml = await response.text();
        const responseDoc = new DOMParser().parseFromString(responseHtml, 'text/html');
        const totalSource = responseDoc.querySelector('[data-ajax-cart] .alp-cart-total');
        if (totalSource) totalTarget.innerHTML = totalSource.innerHTML;
      }

      async updateCartCount(itemCount) {
        let count = itemCount;
        if (typeof count !== 'number') {
          try {
            count = (await this.fetchCart()).item_count;
          } catch {
            return;
          }
        }
        document.querySelectorAll('.cart-count').forEach((element) => {
          element.textContent = String(count);
        });
      }

      async removeGiftLines(lines) {
        const updates = {};
        lines.forEach((line) => {
          updates[line.key] = 0;
        });
        if (!Object.keys(updates).length) return;

        this.dataset.busy = 'true';
        try {
          const response = await fetch(this.dataset.cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ updates }),
          });
          if (!response.ok) throw new Error('Unable to remove gift');
          return response.json();
        } finally {
          delete this.dataset.busy;
        }
      }

      async addGift(variantId) {
        this.dataset.busy = 'true';
        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: 1,
                  properties: { [this.giftProperty]: this.promotionId },
                },
              ],
            }),
          });
          if (!response.ok) throw new Error('Unable to add gift');
          return response.json();
        } finally {
          delete this.dataset.busy;
        }
      }

      getSavedSelection() {
        try {
          const value = window.localStorage.getItem(this.storageKey);
          return this.giftVariantIds.has(value) ? value : null;
        } catch {
          return null;
        }
      }

      saveSelection(variantId) {
        try {
          window.localStorage.setItem(this.storageKey, variantId);
        } catch {}
      }
    }

    customElements.define('cart-quantity-gift', CartQuantityGift);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-cart-recommendations-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-recommendations-v1')) {
    class CartRecommendationsV1 extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.cartRoot = this.closest('[data-ajax-cart]');
        this.cartItemsRoot = this.cartRoot?.querySelector('.alp-cart-items-wrapper');
        this.updateAddedState = this.updateAddedState.bind(this);

        if (this.cartItemsRoot) {
          this.cartObserver = new MutationObserver(this.updateAddedState);
          this.cartObserver.observe(this.cartItemsRoot, { childList: true, subtree: true });
        }
        this.updateAddedState();
      }

      disconnectedCallback() {
        this.cartObserver?.disconnect();
      }

      updateAddedState() {
        const cartProductIds = new Set(
          [...(this.cartRoot?.querySelectorAll('.alp-cart-line-item[data-line-product-id]') || [])].map(
            (lineItem) => lineItem.dataset.lineProductId
          )
        );

        this.querySelectorAll('[data-recommendations-v1-item]').forEach((item) => {
          const isAdded = cartProductIds.has(item.dataset.recommendProductId);
          const button = item.querySelector('[data-recommendations-v1-button]');
          const addText = item.querySelector('[data-recommendations-v1-add-text]');
          const addedText = item.querySelector('[data-recommendations-v1-added-text]');

          item.classList.toggle('is-added', isAdded);
          if (button) {
            button.disabled = isAdded;
            button.setAttribute('aria-pressed', String(isAdded));
          }
          if (addText) addText.hidden = isAdded;
          if (addedText) addedText.hidden = !isAdded;
        });
      }
    }

    customElements.define('cart-recommendations-v1', CartRecommendationsV1);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-cart-tag-quantity-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-tag-quantity-notice')) {
    class CartTagQuantityNotice extends HTMLElement {
      connectedCallback() {
        this.textOneEl = this.querySelector('[data-notice-text-one]');
        this.textTwoEl = this.querySelector('[data-notice-text-two]');
        this.triggerTag = this.dataset.triggerTag?.trim();
        this.triggerQuantity = Number.parseInt(this.dataset.triggerQuantity, 10) || 2;
        this.targetSelector = this.dataset.targetSelector?.trim();
        this.insertPosition = this.dataset.insertPosition === 'prepend' ? 'prepend' : 'append';
        this.displayDuration = Number.parseInt(this.dataset.displayDuration, 10) || 5000;
        this.textAlign = this.dataset.textAlign || 'center';
        this.alwaysShow = this.dataset.alwaysShow !== 'false';
        this.activeBubble = null;
        this.collapseTimer = null;
        this.removeTimer = null;

        if (!this.triggerTag || !this.targetSelector) return;

        this.onAddToCartSuccess = this.onAddToCartSuccess.bind(this);
        this.onCartRefresh = this.onCartRefresh.bind(this);

        if (this.alwaysShow) {
          window.addEventListener('refreshAjaxCart', this.onCartRefresh);
          this.updatePersistentNotice();
        } else {
          document.addEventListener('lx-add-to-cart:success', this.onAddToCartSuccess);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('lx-add-to-cart:success', this.onAddToCartSuccess);
        window.removeEventListener('refreshAjaxCart', this.onCartRefresh);
        this.clearTimers();
        this.removeActiveBubble();
      }

      onCartRefresh() {
        if (!this.alwaysShow) return;
        this.updatePersistentNotice();
      }

      updatePersistentNotice() {
        const content = this.resolveNoticeContent();

        if (!content) {
          this.clearTimers();
          this.removeActiveBubble();
          return;
        }

        const target = this.findTarget();
        if (!target) return;

        if (this.activeBubble?.isConnected) {
          this.activeBubble.classList.add('is-persistent', 'is-expanded');
          const inner = this.activeBubble.querySelector('.alp-cart-tag-quantity-notice__bubble-inner');
          if (inner) {
            if (inner.innerHTML !== content) {
              inner.innerHTML = content;
            }
            inner.style.textAlign = this.textAlign;
          }
          return;
        }

        const existingBubble = target.querySelector('.alp-cart-tag-quantity-notice__bubble');
        if (existingBubble?.isConnected) {
          this.activeBubble = existingBubble;
          existingBubble.classList.add('is-persistent', 'is-expanded');
          const inner = existingBubble.querySelector('.alp-cart-tag-quantity-notice__bubble-inner');
          if (inner) {
            inner.innerHTML = content;
            inner.style.textAlign = this.textAlign;
          }
          return;
        }

        this.activeBubble = null;
        this.showNotice(target, content, true);
      }

      onAddToCartSuccess() {
        const content = this.resolveNoticeContent();
        if (!content) {
          this.clearTimers();
          this.removeActiveBubble();
          return;
        }

        const target = this.findTarget();
        if (!target) return;

        this.showNotice(target, content);
      }

      getMatchingQuantity() {
        const cartRoot = this.closest('[data-ajax-cart]') || document;
        const lineItems = cartRoot.querySelectorAll('.alp-cart-line-item[data-line-tags]');
        let count = 0;

        lineItems.forEach((item) => {
          const tags = (item.dataset.lineTags || '')
            .split(',')
            .map((tag) => tag.trim())
            .filter(Boolean);
          if (tags.includes(this.triggerTag)) {
            count += Number.parseInt(item.dataset.lineQuantity, 10) || 0;
          }
        });

        return count;
      }

      resolveNoticeContent() {
        const count = this.getMatchingQuantity();
        if (count >= this.triggerQuantity) {
          return this.textTwoEl?.innerHTML?.trim() || '';
        }
        if (count === 1) {
          return this.textOneEl?.innerHTML?.trim() || '';
        }
        return '';
      }

      findTarget() {
        const scope = this.closest('[data-ajax-cart]') || document;
        return scope.querySelector(this.targetSelector) || document.querySelector(this.targetSelector);
      }

      showNotice(target, value, isPersistent) {
        this.clearTimers();
        this.removeActiveBubble();

        const persistent = isPersistent === true || (isPersistent !== false && this.alwaysShow);

        const bubble = document.createElement('span');
        bubble.className = 'alp-cart-tag-quantity-notice__bubble';
        if (persistent) {
          bubble.classList.add('is-persistent');
        }
        bubble.dataset.insertPosition = this.insertPosition;
        bubble.style.setProperty('--margin-y', this.dataset.customMarginY || '0px');
        bubble.style.setProperty('--margin-x', this.dataset.customMarginX || '0px');
        bubble.setAttribute('role', 'status');
        bubble.setAttribute('aria-live', 'polite');
        const inner = document.createElement('span');
        inner.className = 'alp-cart-tag-quantity-notice__bubble-inner';
        inner.style.backgroundColor = this.dataset.noticeBubbleBgColor;
        inner.style.color = this.dataset.noticeBubbleTextColor;
        inner.style.textAlign = this.textAlign;
        inner.innerHTML = value;
        bubble.append(inner);

        if (this.insertPosition === 'prepend') {
          target.prepend(bubble);
        } else {
          target.append(bubble);
        }

        this.activeBubble = bubble;

        if (persistent) {
          bubble.classList.add('is-expanded');
          return;
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            bubble.classList.add('is-expanded');
          });
        });

        this.collapseTimer = window.setTimeout(() => {
          this.collapseNotice(bubble);
        }, this.displayDuration);
      }

      collapseNotice(bubble) {
        if (!bubble?.isConnected) return;

        bubble.classList.remove('is-expanded');
        bubble.classList.add('is-collapsing');

        const onTransitionEnd = (event) => {
          if (event.target !== bubble && event.target !== bubble.firstElementChild) return;
          bubble.removeEventListener('transitionend', onTransitionEnd);
          bubble.remove();
          if (this.activeBubble === bubble) {
            this.activeBubble = null;
          }
        };

        bubble.addEventListener('transitionend', onTransitionEnd);

        this.removeTimer = window.setTimeout(() => {
          bubble.removeEventListener('transitionend', onTransitionEnd);
          bubble.remove();
          if (this.activeBubble === bubble) {
            this.activeBubble = null;
          }
        }, 600);
      }

      clearTimers() {
        if (this.collapseTimer) {
          window.clearTimeout(this.collapseTimer);
          this.collapseTimer = null;
        }
        if (this.removeTimer) {
          window.clearTimeout(this.removeTimer);
          this.removeTimer = null;
        }
      }

      removeActiveBubble() {
        this.activeBubble?.remove();
        this.activeBubble = null;
      }
    }

    customElements.define('cart-tag-quantity-notice', CartTagQuantityNotice);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-dropdown-sub-mega-menu-v1"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    class MegaTab extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        const tabs = this.querySelectorAll(`[data-menu-title]`);
        const content = this.querySelectorAll(`[data-tabs-content] > div`);
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            tabs.forEach((item) => {
              item.classList.remove('active');
            });
            tab.classList.add('active');
            content.forEach((item) => {
              item.classList.add('hidden');
            });
            const target = content[index];
            target.classList.remove('hidden');
          });
        });
        content.forEach((item) => {
          item.classList.add('hidden');
        });
        content[0].classList.remove('hidden');
        tabs[0].classList.add('active');

        // swiper tab navigation
        const swiperNav = this.querySelector('.mega-category-nav-swiper-v1');
        const swiperNavList = this.querySelector('.mega-category-nav-swiper-v1-list');
        const swiperNavItems = swiperNavList.querySelectorAll('.swiper-slide');
        const swiperNavSwiper = new Swiper(swiperNav, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          breakpoints: {
            768: {
              spaceBetween: 24,
            },
          },
        });
        swiperNavItems.forEach((item) => {
          item.addEventListener('click', () => {
            swiperNavSwiper.slideTo(index);
          });
        });
      }
    }
    customElements.define('lx-mega-tab', MegaTab);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-product-coupon-snippet"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.alp_product_coupon_container').forEach(function (container) {
      const couponBtn = container.querySelector('.alp_product_coupon_right');
      couponBtn.addEventListener('click', function () {
        if (!container.querySelector('.alp_product_coupon_hidden')) {
          return;
        }
        const textToCopy = container.querySelector('.alp_product_coupon_hidden').dataset.discountCode;
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            console.log('文本已成功复制: ', textToCopy);
            const notification = $(container).find('.copyNotification');
            notification.stop().slideDown(300);
            setTimeout(() => {
              notification.stop().slideUp(200);
            }, 5000);
          })
          .catch((err) => {
            console.log('复制失败: ', err);
          });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-discount-code-field"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#axx-discount-form');
    const input = form.querySelector('.axx-discount-code');
    const messageEl = form.querySelector('.axx-discount-message');
    const appliedContainer = form.querySelector('.axx-applied-discounts');
    const summaryContainer = document.querySelector('.axx-ajax-cart-discount-summary');

    if (!form || !input || !messageEl || !appliedContainer) return;

    // --- Helpers -------------------------------------------------------------

    // Fetch the current cart JSON
    function fetchCart() {
      return fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: {
          Accept: 'application/json',
        },
      }).then((res) => res.json());
    }

    // Extract discount codes from the cart JSON
    //
    // Depending on theme/Shopify version, discount codes may show as:
    // - cart.cart_level_discount_applications (type: 'discount_code')
    // - or sometimes cart.discount_code / cart.discount_codes (older)
    //
    // We normalize to an array of { code, title }.
    function getDiscountCodesFromCart(cart) {
      const codes = [];

      // Newer style: cart_level_discount_applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          // Only include discount-code-based apps, skip automatic discounts
          if (app.type === 'discount_code' && app.code) {
            codes.push({
              code: app.code,
              title: app.title || app.code,
            });
          }
        });
      }

      // Older style: cart.discount_code (single) or cart.discount_codes (array)
      if (!codes.length && cart.discount_code) {
        codes.push({ code: cart.discount_code, title: cart.discount_code });
      }

      if (!codes.length && Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach((dc) => {
          if (dc.code) {
            codes.push({ code: dc.code, title: dc.code });
          }
        });
      }

      return codes;
    }

    // Build the `discount` string for /cart/update.js from a list of codes
    // e.g. ['SAVE10','SHIPFREE'] -> 'SAVE10,SHIPFREE'
    function formatDiscountString(codes) {
      return codes.join(',');
    }

    // Render applied discount codes under the input
    function renderAppliedDiscounts(codes) {
      if (!codes.length) {
        appliedContainer.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'applied-discount-list';

      codes.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'applied-discount-item';

        const codeSpan = document.createElement('span');
        codeSpan.className = 'applied-discount-code';
        codeSpan.textContent = item.code;

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'applied-discount-remove';
        removeBtn.setAttribute('aria-label', `Remove discount code ${item.code}`);
        removeBtn.textContent = '×'; // Remove icon

        removeBtn.addEventListener('click', () => {
          removeDiscountCode(item.code);
        });

        li.appendChild(codeSpan);
        li.appendChild(removeBtn);
        list.appendChild(li);
      });

      appliedContainer.innerHTML = '';
      appliedContainer.appendChild(list);
    }

    // Apply ALL discount codes to the cart via /cart/update.js
    function updateCartDiscounts(codes) {
      // check if the codes can not combine, return the applied codes that can be combined
      codes = codesCanNotCombineCheck(window.codesCanNotCombineArray, codes);

      const discountString = codes.length ? formatDiscountString(codes) : '';

      return fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          discount: discountString,
        }),
      }).then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw data;
          });
        }
        return response.json();
      });
    }

    function showMessage(message, error = false) {
      messageEl.textContent = message;
      messageEl.classList.remove('hidden');
      if (error) {
        messageEl.classList.add('error');
      } else {
        messageEl.classList.remove('error');
      }
      setTimeout(() => {
        messageEl.classList.add('hidden');
        messageEl.classList.remove('error');
      }, 4000);
    }

    // Remove a single code from the list and update the cart
    function removeDiscountCode(codeToRemove, message, error = false) {
      form.classList.add('loading');
      fetchCart()
        .then((cart) => {
          const codes = getDiscountCodesFromCart(cart).map((c) => c.code);
          const remaining = codes.filter((c) => c !== codeToRemove);

          return updateCartDiscounts(remaining);
        })
        .then((updatedCart) => {
          showMessage(message || `${codeToRemove} removed.`, error);

          const currentCodes = getDiscountCodesFromCart(updatedCart).map((c) => c.code);
          renderAppliedDiscounts(getDiscountCodesFromCart(updatedCart));

          // Optionally: refresh totals / cart UI from updatedCart
          console.log('Updated cart after removing code:', codeToRemove);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // refresh cart
          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error removing discount:', error);
          showMessage('Unable to remove discount. Please try again.', true);
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // --- Init: fetch cart and render applied codes --------------------------

    async function init(loading = true) {
      fetchCart()
        .then((cart) => {
          // const codes = getDiscountCodesFromCart(cart);
          // renderAppliedDiscounts(codes);
          if (loading) {
            form.classList.add('loading');
          } else {
            form.classList.add('updating');
          }
          let AllCodes = cart.discount_codes;
          let appliedCodes = [];
          AllCodes.forEach((code) => {
            if (code.applicable) {
              appliedCodes.push(code.code);
            }
          });
          appliedCodesToStr = appliedCodes.join(',');
          let updates = {
            discount: appliedCodesToStr,
          };
          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updates),
          })
            .then((response) => response.json())
            .then((data) => {
              // console.log(data);
              const codes = getDiscountCodesFromCart(data);
              renderAppliedDiscounts(codes);
              console.log('Applied discount codes:', codes);

              // update discount summary
              const grouped = getGroupedDiscountsFromCart(data);
              renderDiscountSummary(summaryContainer, grouped);

              form.classList.remove('loading');
              form.classList.remove('updating');
            });
        })
        .catch((err) => {
          console.error('Error fetching cart:', err);
          form.classList.remove('loading');
          form.classList.remove('updating');
        });
    }

    window.addEventListener('refreshAjaxCart', () => init(true));

    // add newCode
    function addNewCode(newCode) {
      form.classList.add('loading');
      // Strategy:
      // 1. Fetch current cart & existing codes
      // 2. Add new code to the list (if not already present)
      // 3. POST all codes as a single string to cart/update.js
      fetchCart()
        .then((cart) => {
          const existingCodes = getDiscountCodesFromCart(cart).map((c) => c.code.toLowerCase());

          const mergedCodes = [...new Set([...existingCodes, newCode.toLowerCase()])];

          return updateCartDiscounts(mergedCodes);
        })
        .then((updatedCart) => {
          // check if the discount is applicable, if not, show the error message and remove this discount code
          let thisCode = updatedCart.discount_codes.find((code) => code.code.toLowerCase() === newCode.toLowerCase());
          if (thisCode && !thisCode.applicable) {
            console.log('Discount is not applicable:', thisCode);
            removeDiscountCode(thisCode.code.toLowerCase(), `${thisCode.code} is not applicable.`, true);
            input.value = '';
            return;
          }

          // showMessage('Discount applied.');

          input.value = '';

          const codes = getDiscountCodesFromCart(updatedCart);
          renderAppliedDiscounts(codes);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // Optionally: re-render cart totals, etc.
          console.log('Updated cart with discount(s):', codes);

          // refresh line item discount summary and cart

          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error applying discount:', error);
          showMessage('Unable to apply this discount.', true);
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // codes can not combine
    function codesCanNotCombineCheck(codesNotCombineArray, appliedCodes) {
      codesNotCombineArray = codesNotCombineArray || [];
      appliedCodes = appliedCodes || [];

      if (codesNotCombineArray.length === 0 || appliedCodes.length === 0) {
        return appliedCodes;
      }

      let finalCodesToRemove = [];
      // for each codes in codesNotCombineArray, check if it is in appliedCodes
      for (let i = 0; i < codesNotCombineArray.length; i++) {
        if (appliedCodes.includes(codesNotCombineArray[i])) {
          finalCodesToRemove.push(codesNotCombineArray[i]);
        }
      }

      if (finalCodesToRemove.length > 1) {
        for (let i = 0; i < finalCodesToRemove.length; i++) {
          if (i > 0) {
            appliedCodes.splice(appliedCodes.indexOf(finalCodesToRemove[i]), 1);
          }
        }

        // show message
        // showMessage(`${finalCodesToRemove.join(', ')} are not combineable together.`);
        console.log('Codes Can Not Combine:', finalCodesToRemove);
        console.log('Final Applied Codes:', appliedCodes);
      }
      return appliedCodes;
    }

    // --- Form submit: apply a discount code ---------------------------------

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const newCode = input.value.trim();
      if (!newCode) {
        // showMessage('Please enter a discount code.');
        return;
      }

      addNewCode(newCode);
    });

    // discount-summary -----------------------------------

    // Build a friendly label from a discount_application / cart_level_discount_application
    function getDiscountLabel(app) {
      // Prefer a human-readable title; fallback to code; fallback to type
      return app.title || app.code || app.type || 'Discount';
    }

    // Returns array of { label, totalAmount } where totalAmount is a number (in shop currency)
    function getGroupedDiscountsFromCart(cart) {
      const groups = Object.create(null); // { [label]: totalAmountNumber }

      // 1) Line-item level discounts
      if (Array.isArray(cart.items)) {
        cart.items.forEach((item) => {
          if (!Array.isArray(item.line_level_discount_allocations)) return;

          item.line_level_discount_allocations.forEach((alloc) => {
            const app = alloc.discount_application || {};
            const label = getDiscountLabel(app);
            const amount = parseFloat(alloc.amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          });
        });
      }

      // 2) Cart-level discount applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          let thisApp = app.discount_application || app;
          // console.log('cart_level_discount_applications:', thisApp);
          if (thisApp.type === 'discount_code') {
            const label = getDiscountLabel(thisApp);
            const amount = parseFloat(thisApp.total_allocated_amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          }
        });
      }

      // Convert map → array
      return Object.keys(groups).map((label) => ({
        label,
        totalAmount: groups[label],
      }));
    }

    function formatMoneyFromNumber(amount) {
      // amount is a number in store currency (e.g. 5 -> $5.00)
      // Use Shopify's money formatting if needed; this simple example uses Intl
      // Adjust currency code and locale to your store.
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.shopCurrentCurrency,
      }).format(amount);
    }

    function renderDiscountSummary(container, discounts) {
      if (!container) return;

      if (!discounts.length) {
        container.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'discount-summary-list';

      discounts.forEach((d) => {
        const li = document.createElement('li');
        li.className = 'discount-summary-item';

        const nameSpan = document.createElement('span');
        nameSpan.className = 'discount-summary-name';
        nameSpan.innerHTML = `${window.shopDiscountLabelSvgHtml} ${d.label}`;

        const amountSpan = document.createElement('span');
        amountSpan.className = 'discount-summary-amount';
        // Show as negative amount
        amountSpan.textContent = '-' + formatMoneyFromNumber(d.totalAmount / 100.0);

        li.appendChild(nameSpan);
        li.appendChild(amountSpan);
        list.appendChild(li);
      });

      container.innerHTML = '';
      container.appendChild(list);
    }

    window.refreshAjaxCartDiscountSummary = () => {
      fetchCart()
        .then((cart) => {
          const grouped = getGroupedDiscountsFromCart(cart);
          renderDiscountSummary(summaryContainer, grouped);
        })
        .catch((err) => {
          console.error('Error fetching cart for discounts:', err);
        });
    };

    init();
    // window.refreshAjaxCartDiscountSummary();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-variants-swatch"] && !Shopify.designMode) return;
  try {
    window.AXXVariantsSwatch = class {
    // 选择器 [data-axx-swatch]
    // 父级 [data-product-swatch]
    // 图片 [data-product-swatch-images]
    // 价格容器 [data-product-swatch-price]
    // 价格值 [data-product-swatch-price-value]
    // 对比价格 [data-product-swatch-compare-price-value]
    // url [data-product-swatch-url]

    constructor() {
      this.products = [];
      // 存储事件处理函数
      this.eventListeners = new Map();
    }

    init() {
      this.products = document.querySelectorAll('[data-axx-swatch]');
      this.products.forEach((product) => {
        let form = product.querySelector('form');
        // 创建事件处理函数
        const handler = (e) => this.handlerChange(product, form);
        // 存储事件处理函数
        this.eventListeners.set(form, handler);
        // 添加事件监听器
        form.addEventListener('change', handler);
      });
    }

    update() {
      this.products.forEach((product) => {
        let form = product.querySelector('form');
        // 获取存储的事件处理函数
        const handler = this.eventListeners.get(form);
        if (handler) {
          // 移除事件监听器
          form.removeEventListener('change', handler);
          // 清理存储的引用
          this.eventListeners.delete(form);
        }
      });
      this.products = [];
      this.init();
    }

    handlerChange(product, form) {
      const fieldsets = Array.from(form.querySelectorAll('[data-form-input]'));
      let options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
      this.updateCurrentVariant(product, options);
    }

    areArraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      const sortedArr1 = [...arr1].sort();
      const sortedArr2 = [...arr2].sort();
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          return false;
        }
      }
      return true;
    }

    getVariantData(product) {
      let variantData = JSON.parse(product.querySelector('[type="application/json"]').textContent);
      return variantData;
    }

    updateCurrentVariant(product, options) {
      let currentVariant = null;
      this.getVariantData(product).find((variant) => {
        // match the current variant
        if (this.areArraysEqual(variant.options, options)) {
          currentVariant = variant;
        }
      });
      // console.log(currentVariant.id);
      if (currentVariant) {
        this.setProductInfo(product, currentVariant);
        this.updateVariantStatuses(product, currentVariant);
      }
    }

    updateVariantStatuses(product, currentVariant) {
      let $this = this;
      let forms = product.querySelector('form').querySelectorAll('[data-form-input]');
      if (forms.length < 2) {
        return;
      }
      // Disable all inputs
      forms.forEach((form) => {
        form.querySelectorAll('input').forEach((input) => {
          input.classList.add('disabled');
        });
      });
      // Enable only the matched inputs
      forms.forEach((form, index) => {
        let checkedInput = form.querySelector(':checked');
        let matchedVariants = $this
          .getVariantData(product)
          .filter((variant) => variant.options[index] === checkedInput.value);
        // console.log(matchedVariants);
        matchedVariants.forEach((variant) => {
          let available = variant.available;
          variant.options.forEach((option, optionIndex) => {
            if (optionIndex !== index) {
              // console.log(option);
              let optionInputs = forms[optionIndex].querySelectorAll(`input[value="${option}"]`);
              optionInputs.forEach((input) => {
                if (available) {
                  input.classList.remove('disabled');
                }
              });
            }
          });
        });
      });
    }

    setProductInfo(product, variant) {
      let productId = product.dataset.productId;
      let productUrl = product.dataset.productUrl;
      let productUrlWithVariant = productUrl + '?variant=' + variant.id;
      let productInfo = {
        id: variant.id,
        price: variant.price,
        compare_at_price: variant.compare_at_price,
        image: variant.featured_image.src,
        image_id: variant.featured_image.id,
        url: productUrlWithVariant,
        options: variant.options,
        available: variant.available,
      };
      this.updateProductInfo(product, productId, productInfo);
      this.sendCustomEvent(product, productId, 'variant:change', productInfo);
      // console log
      console.log(`SwatchChanged:[product:${productId}],[variant:${variant.id}]`);
    }

    updateProductInfo(product, productId, productInfo) {
      // match the parent element '[data-product-swatch]'
      let parent = product.closest('[data-product-swatch]');
      // update product data info
      if (parent) {
        parent.dataset.productInfo = JSON.stringify(productInfo);
        // update images src and srcset
        let images = parent.querySelectorAll(`[data-product-swatch-images]`);
        if (images) {
          images.forEach((image) => {
            let imageInfo = JSON.parse(image.querySelector('[type="application/json"]').textContent);
            imageInfo.variants.forEach((variant) => {
              if (variant.id === productInfo.id) {
                image.querySelector('img').src = variant.image.src;
                image.querySelector('img').srcset = variant.image.srcset;
              }
            });
          });
        }
        // update price
        let priceWarpper = parent.querySelectorAll('[data-product-swatch-price]');
        if (priceWarpper) {
          priceWarpper.forEach((price) => {
            let the_price = price.querySelector('[data-product-swatch-price-value]');
            let the_compare_price = price.querySelector('[data-product-swatch-compare-price-value]');
            let priceInfo = JSON.parse(price.querySelector('[type="application/json"]').textContent);
            priceInfo.variants.forEach((variant) => {
              if (variant.id === productInfo.id) {
                the_price.textContent = variant.price;
                the_compare_price.textContent = variant.compare_at_price;
                if (variant.compare_at_price) {
                  the_compare_price.classList.remove('hidden');
                } else {
                  the_compare_price.classList.add('hidden');
                }
              }
            });
          });
        }
        // update url
        let urlWarpper = parent.querySelectorAll('[data-product-swatch-url]');
        if (urlWarpper) {
          urlWarpper.forEach((url) => {
            url.setAttribute('href', productInfo.url);
          });
        }
      }
    }

    sendCustomEvent(product, productId, eventName, detail) {
      let parent = product.closest('[data-product-swatch]');
      if (parent) {
        let event = new CustomEvent(eventName, { detail });
        parent.dispatchEvent(event);
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.axxVariantsSwatch = new window.AXXVariantsSwatch();
    window.axxVariantsSwatch.init();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-360-viewer-popup"] && !Shopify.designMode) return;
  try {
    class LX360Viewer extends HTMLElement {
    static TOTAL_STEPS = 720;

    constructor() {
      super();
      this._realIndex = 0;
      this._currentStep = 0;
      this._ratio = 1;
      this._onOpen = this.handleOpenClick.bind(this);
      this._onClose = this.handleClose.bind(this);
      this._onOutsideClick = this.handleOutsideClick.bind(this);
      this._onUpdateViewer = this.handleUpdateViewer.bind(this);
    }

    connectedCallback() {
      this.imageNumber = Number(this.dataset.imageNumber) || 0;
      this.defaultImage = Number(this.dataset.defaultImage) || 0;

      if (this.imageNumber <= 0) return;

      this.openBtn = this.querySelector('.lx-v360-viewer__open');
      this.overlay = this.querySelector('.lx-v360-viewer__overlay');
      this.stage = this.querySelector('.lx-v360-viewer__stage');
      this.tips = this.querySelector('.lx-v360-viewer__tips');
      this.frames = this.querySelectorAll('.lx-v360-viewer__frame');

      this._ratio = LX360Viewer.TOTAL_STEPS / this.imageNumber;
      this._realIndex = Math.min(this.defaultImage, this.frames.length - 1);
      this._currentStep = this._realIndex * this._ratio;

      this.overlay?.classList.add('lx-v360-viewer__overlay--hidden');

      this.openBtn?.addEventListener('click', this._onOpen);
      this.querySelector('.lx-v360-viewer__close')?.addEventListener('click', this._onClose);
      window.addEventListener('updateViewer', this._onUpdateViewer);

      this.setActiveFrame(this._realIndex);
      this.waitForObserverAndInit();
    }

    disconnectedCallback() {
      this.openBtn?.removeEventListener('click', this._onOpen);
      this.querySelector('.lx-v360-viewer__close')?.removeEventListener('click', this._onClose);
      window.removeEventListener('updateViewer', this._onUpdateViewer);
      this.unbindOutsideClick();
      this._observer?.kill();
      this._observer = null;
    }

    isOpen() {
      return this.overlay?.classList.contains('lx-v360-viewer__overlay--active') ?? false;
    }

    bindOutsideClick() {
      requestAnimationFrame(() => {
        document.addEventListener('click', this._onOutsideClick, true);
      });
    }

    unbindOutsideClick() {
      document.removeEventListener('click', this._onOutsideClick, true);
    }

    handleOpenClick(event) {
      event.stopPropagation();
      this.handleOpen();
    }

    handleOutsideClick(event) {
      if (!this.isOpen() || this.contains(event.target)) return;
      this.handleClose();
    }

    waitForObserverAndInit(attempt = 0) {
      const Observer = window.gsap?.Observer || window.Observer;
      if (Observer && this.stage) {
        window.gsap?.registerPlugin?.(Observer);
        this.initObserver(Observer);
        return;
      }
      if (attempt > 50) return;
      requestAnimationFrame(() => this.waitForObserverAndInit(attempt + 1));
    }

    initObserver(Observer) {
      this._observer = Observer.create({
        target: this.stage,
        type: 'touch,pointer',
        onDrag: (self) => this.updateStep(self.deltaX),
        onDragStart: () => {
          this.tips?.classList.add('lx-v360-viewer__tips--hidden');
          this.classList.add('lx-v360-viewer--dragging');
        },
        onDragEnd: () => {
          this.tips?.classList.remove('lx-v360-viewer__tips--hidden');
          this.classList.remove('lx-v360-viewer--dragging');
        },
      });
    }

    setActiveFrame(index) {
      this.frames.forEach((frame, i) => {
        frame.classList.toggle('lx-v360-viewer__frame--active', i === index);
      });
    }

    updateStep(deltaX) {
      this._currentStep = Math.round(this._currentStep + deltaX);

      if (this._currentStep < 0) {
        this._currentStep = LX360Viewer.TOTAL_STEPS;
      } else if (this._currentStep > LX360Viewer.TOTAL_STEPS) {
        this._currentStep = 0;
      }

      this._realIndex = Math.round(this._currentStep / this._ratio);
      this.setActiveFrame(this._realIndex);
    }

    handleUpdateViewer() {
      this.setActiveFrame(this._realIndex);
    }

    handleOpen() {
      if (!this.overlay) return;

      this.overlay.classList.remove('lx-v360-viewer__overlay--hidden');
      window.lazyLoadInstance?.update?.();

      requestAnimationFrame(() => {
        this.overlay.classList.add('lx-v360-viewer__overlay--active', 'lx-v360-viewer__overlay--loaded');
      });

      this.openBtn?.classList.add('lx-v360-viewer__open--hidden');
      this.bindOutsideClick();
    }

    handleClose() {
      if (!this.overlay) return;

      this.unbindOutsideClick();
      this.overlay.classList.remove('lx-v360-viewer__overlay--active');
      this.openBtn?.classList.remove('lx-v360-viewer__open--hidden');

      setTimeout(() => {
        this.overlay.classList.add('lx-v360-viewer__overlay--hidden');
        this.overlay.classList.remove('lx-v360-viewer__overlay--loaded');
      }, 600);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('lx-360-viewer')) {
      customElements.define('lx-360-viewer', LX360Viewer);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-buy-buttons"] && !Shopify.designMode) return;
  try {
    class LXSubmitButton extends HTMLElement {
    constructor() {
      super();
      this.handleSubmit = this.handleSubmit.bind(this);
      this.AdditionalProductsAddCart = this.AdditionalProductsAddCart.bind(this);
    }

    connectedCallback() {
      this.form = this.closest('form');
      this.button = this.querySelector('[data-lx-add-to-cart-button]');
      this.variantInput = this.querySelector('[name="id"]');

      if (!this.form || !this.button) return;

      this.form.addEventListener('submit', this.handleSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit);
    }

    getShopifyRoot() {
      return window.Shopify?.routes?.root || '/';
    }

    setLoading(loading) {
      if (!this.button) return;

      this.button.classList.toggle('loading', loading);

      if (loading) {
        this.button.setAttribute('aria-disabled', 'true');
        this.button.disabled = true;
        return;
      }

      const variantAvailable = this.variantInput && !this.variantInput.disabled;
      this.button.disabled = !variantAvailable;
      if (variantAvailable) {
        this.button.removeAttribute('aria-disabled');
      } else {
        this.button.setAttribute('aria-disabled', 'true');
      }
    }

    AdditionalProductsAddCart() {
      const items = [];

      document.querySelectorAll('[data-addional-product].selected').forEach((el) => {
        const variantId = el.querySelector('select')?.value;
        if (variantId) items.push({ id: variantId });
      });
      document.querySelectorAll('[data-promotion-pack].selected').forEach((el) => {
        const variantId = el.getAttribute('data-pack-variant');
        if (variantId) items.push({ id: variantId });
      });
      document.querySelectorAll('[data-compatible-product].selected').forEach((el) => {
        const variantId = el.getAttribute('data-compatible-variant');
        if (variantId) items.push({ id: variantId });
      });

      return items;
    }

    getFormQuantity() {
      const quantityInput = this.form?.querySelector('lx-quantity-input [name="quantity"]');
      const quantity = Number(quantityInput?.value || 1);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    getFormProperties() {
      if (!this.form) return {};

      const properties = {};
      const formData = new FormData(this.form);

      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') {
          properties[match[1]] = value;
        }
      }

      return properties;
    }

    buildCartItems(variantId, quantity) {
      const items = [
        {
          id: variantId,
          quantity,
          properties: this.getFormProperties(),
        },
      ];

      this.AdditionalProductsAddCart().forEach((item) => {
        items.push({
          id: item.id,
          quantity,
          properties: item.properties || {},
        });
      });

      return items;
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (!this.form || !this.button || this.button.disabled) return;

      const variantId = this.variantInput?.value;
      if (!variantId || this.variantInput?.disabled) return;

      this.setLoading(true);
      this.form.classList.add('ajaxForm', 'loading');

      try {
        const quantity = this.getFormQuantity();
        const cartItems = this.buildCartItems(variantId, quantity);

        let response;
        if (typeof AlpFn !== 'undefined' && typeof AlpFn.AddToCartMulti === 'function') {
          response = await AlpFn.AddToCartMulti(cartItems);
        } else {
          const formData = new FormData(this.form);
          response = await fetch(`${this.getShopifyRoot()}cart/add.js`, {
            method: 'POST',
            body: formData,
          });
        }

        if (!response || response === false) {
          throw new Error('Add to cart failed');
        }

        const data = await response
          .clone()
          .json()
          .catch(() => ({}));

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        if (typeof AlpFn !== 'undefined' && typeof AlpFn.refreshCart === 'function') {
          await AlpFn.refreshCart('[data-ajax-cart]', response);
          document.body.classList.add('cart-open');
          const cartDrawer = document.querySelector('[data-ajax-cart]');
          setTimeout(() => {
            cartDrawer?.classList.add('open');
            document.body.classList.add('noscroll');
          }, 50);
        } else if (window.routes?.cart_url) {
          window.location = window.routes.cart_url;
        }

        this.dispatchEvent(
          new CustomEvent('lx-add-to-cart:success', {
            bubbles: true,
            detail: { variantId, cartItem: data },
          })
        );
      } catch (error) {
        console.error('[lx-submit-button]', error);
        this.dispatchEvent(
          new CustomEvent('lx-add-to-cart:error', {
            bubbles: true,
            detail: { message: error?.message || 'Add to cart failed' },
          })
        );
      } finally {
        this.form?.classList.remove('loading');
        this.setLoading(false);
        this.dispatchEvent(
          new CustomEvent('lx-add-to-cart:finished', {
            bubbles: true,
            detail: { message: 'Add to cart Finished' },
          })
        );
      }
    }
  }

  if (!customElements.get('lx-submit-button')) {
    customElements.define('lx-submit-button', LXSubmitButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-quantity-input"] && !Shopify.designMode) return;
  try {
    class LxQuantityInput extends HTMLElement {
    constructor() {
      super();
      this.field = this.querySelector('.lx-quantity-input__field');
      this.decreaseBtn = this.querySelector('[data-lx-qty-action="decrease"]');
      this.increaseBtn = this.querySelector('[data-lx-qty-action="increase"]');
      this.onFieldChange = this.onFieldChange.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);
    }

    connectedCallback() {
      if (!this.field) return;

      this.field.addEventListener('change', this.onFieldChange);
      this.field.addEventListener('blur', this.onFieldChange);
      this.decreaseBtn?.addEventListener('click', this.onButtonClick);
      this.increaseBtn?.addEventListener('click', this.onButtonClick);

      this.syncValue();
      this.syncButtons();
    }

    disconnectedCallback() {
      this.field?.removeEventListener('change', this.onFieldChange);
      this.field?.removeEventListener('blur', this.onFieldChange);
      this.decreaseBtn?.removeEventListener('click', this.onButtonClick);
      this.increaseBtn?.removeEventListener('click', this.onButtonClick);
    }

    getRules() {
      const min = parseInt(this.field.dataset.lxQtyMin || this.field.min, 10) || 1;
      const step = parseInt(this.field.dataset.lxQtyStep || this.field.step, 10) || 1;
      const maxAttr = this.field.dataset.lxQtyMax || this.field.max;
      const max = maxAttr === '' || maxAttr == null ? null : parseInt(maxAttr, 10);
      return { min, step, max };
    }

    clampValue(rawValue) {
      const { min, step, max } = this.getRules();
      let value = parseInt(rawValue, 10);

      if (Number.isNaN(value)) value = min;

      if (value < min) value = min;

      if (max != null && value > max) value = max;

      const offset = (value - min) % step;
      if (offset !== 0) {
        value = value - offset;
        if (value < min) value = min;
      }

      return value;
    }

    syncValue() {
      this.field.value = String(this.clampValue(this.field.value));
    }

    syncButtons() {
      const { min, max } = this.getRules();
      const value = parseInt(this.field.value, 10);

      if (this.decreaseBtn) {
        this.decreaseBtn.disabled = value <= min;
      }

      if (this.increaseBtn) {
        this.increaseBtn.disabled = max != null && value >= max;
      }
    }

    onFieldChange() {
      this.syncValue();
      this.syncButtons();
    }

    onButtonClick(event) {
      event.preventDefault();
      const action = event.currentTarget?.dataset?.lxQtyAction;
      const { min, step, max } = this.getRules();
      let value = this.clampValue(this.field.value);

      if (action === 'increase') {
        value += step;
        if (max != null && value > max) value = max;
      } else {
        value -= step;
        if (value < min) value = min;
      }

      this.field.value = String(value);
      this.field.dispatchEvent(new Event('change', { bubbles: true }));
      this.syncButtons();
    }
  }

  if (!customElements.get('lx-quantity-input')) {
    customElements.define('lx-quantity-input', LxQuantityInput);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-variant-selector-v1"] && !Shopify.designMode) return;
  try {
    class LXVariantSelectorV1 extends HTMLElement {
    constructor() {
      super();
      this._onFormChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;

      this.variantsScript = this.form.querySelector('script[type="application/json"]');
      this.variants = this.parseVariants();

      this.form.addEventListener('change', this._onFormChange);
      this.syncRadiosFromVariantId(this.dataset.productVariantId);
      this.applyCurrentVariant(true);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this._onFormChange);
    }

    parseVariants() {
      if (!this.variantsScript?.textContent) return [];
      try {
        const data = JSON.parse(this.variantsScript.textContent);
        return Array.isArray(data) ? data : [];
      } catch {
        return [];
      }
    }

    /** 按 option position 顺序读取当前选中的选项值（与 JSON 里 option1/2/3 对齐） */
    getOptionGroups() {
      const root = this.querySelector('.lx-variant-selector__options');
      if (!root) return [];

      return Array.from(root.querySelectorAll('.lx-variant-selector__option')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    }

    getSelectedOptionValues() {
      return this.getOptionGroups().map((group) => {
        const input = group.querySelector('input[type="radio"]:checked');
        return input ? input.value : null;
      });
    }

    variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues) {
      if (variant[`option${posIndex + 1}`] !== candidateValue) return false;

      for (let j = 0; j < selectedValues.length; j += 1) {
        if (j === posIndex) continue;
        const sel = selectedValues[j];
        if (sel == null || sel === '') continue;
        if (variant[`option${j + 1}`] !== sel) return false;
      }

      return true;
    }

    /**
     * 当前选中值下，该维度取 candidateValue、其余维度沿用 selectedValues 时的组合状态。
     * selectedValues 中未选维度（null）不参与约束。
     * 返回 canPurchase、currentVariantNull（无变体行匹配该组合，例如仅有 Standard/Jungle Camo 而无 Large/Jungle Camo）。
     */
    hasAvailableVariantForCandidate(posIndex, candidateValue, selectedValues) {
      let hasAnyVariant = false;
      let hasAvailableVariant = false;

      for (const variant of this.variants) {
        if (!this.variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues)) continue;
        hasAnyVariant = true;
        if (variant.available === true) hasAvailableVariant = true;
      }

      return {
        currentVariantNull: !hasAnyVariant,
        canPurchase: hasAvailableVariant,
      };
    }

    /**
     * 根据当前各组选中项，更新每组内 radio。
     * - 组合在 JSON 中不存在（currentVariantNull）：始终对非当前选中项设置 disabled，忽略 canDisableInputSelection。
     * - 组合存在但售罄：仅当 data-can-disable-input-selection 为 true 时设置 disabled。
     * 已选中的项不 disabled，避免无法改选。
     */
    updateVariantStatuses() {
      if (!this.form || !this.variants.length) return;

      const selectedValues = this.getSelectedOptionValues();
      const groups = this.getOptionGroups();
      const allowDisableForSoldOut = this.dataset.canDisableInputSelection === 'true';

      groups.forEach((group, posIndex) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const { currentVariantNull, canPurchase } = this.hasAvailableVariantForCandidate(
            posIndex,
            input.value,
            selectedValues
          );

          let nativeDisabled = false;
          if (!input.checked) {
            if (currentVariantNull) {
              nativeDisabled = true;
            } else if (allowDisableForSoldOut && !canPurchase) {
              nativeDisabled = true;
            }
          }

          // input.disabled = nativeDisabled;
          input.classList.toggle('unavailable', nativeDisabled);
          input.parentElement.classList.toggle('unavailable', nativeDisabled);

          input.classList.toggle('disabled', currentVariantNull || !canPurchase);
        });
      });
    }

    findVariantByOptions(selectedValues) {
      if (!this.variants.length || selectedValues.some((v) => v == null || v === '')) {
        return null;
      }

      return (
        this.variants.find((variant) =>
          selectedValues.every((val, index) => {
            const key = `option${index + 1}`;
            return variant[key] === val;
          })
        ) || null
      );
    }

    syncRadiosFromVariant(variant) {
      if (!variant || !this.form) return;

      const groups = this.getOptionGroups();
      groups.forEach((group, index) => {
        const targetValue = variant[`option${index + 1}`];
        if (targetValue == null) return;

        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === targetValue;
        });
      });
    }

    findBestComposableVariant(changedPosIndex, changedValue, selectedValues) {
      const candidates = this.variants.filter((variant) => variant[`option${changedPosIndex + 1}`] === changedValue);
      if (!candidates.length) return null;

      const getScore = (variant) => {
        let score = variant.available ? 100 : 0;
        for (let i = 0; i < selectedValues.length; i += 1) {
          if (i === changedPosIndex) continue;
          const selected = selectedValues[i];
          if (selected && variant[`option${i + 1}`] === selected) score += 1;
        }
        return score;
      };

      let best = candidates[0];
      let bestScore = getScore(best);
      for (let i = 1; i < candidates.length; i += 1) {
        const current = candidates[i];
        const score = getScore(current);
        if (score > bestScore) {
          best = current;
          bestScore = score;
        }
      }

      return best;
    }

    syncRadiosFromVariantId(variantId) {
      if (!variantId || !this.variants.length) return;

      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      for (let i = 1; i <= 3; i += 1) {
        const val = variant[`option${i}`];
        if (val == null) continue;

        const inputs = this.form.querySelectorAll(`input[type="radio"][name="option-${i}"]`);
        inputs.forEach((input) => {
          input.checked = input.value === val;
        });
      }
    }

    updateProductInfo(variant, available = true) {
      // match element by [data-product-card] or [data-product-info]
      const productElement = this.closest('[data-product-card]') || this.closest('[data-product-info]');
      if (!productElement) return;
      //   update variant available
      productElement.dataset.variantAvailable = available;
      // update product variant id
      productElement.dataset.productVariantId = available ? String(variant.id) : '';
      // update add variant, match element by [data-add-variant]
      productElement.querySelectorAll('[data-add-variant]').forEach((element) => {
        element.dataset.addVariant = available ? String(variant.id) : '';
      });
      // update product link, match element by [data-product-link]
      productElement.querySelectorAll('[data-product-link]').forEach((element) => {
        element.href = available ? `${this.dataset.productUrl}?variant=${variant.id}` : `${this.dataset.productUrl}`;
      });
      // update product image, match element by [data-product-image]
      if (variant) {
        const imageWidth = Math.max(320, Math.min(800, window.innerWidth * 1.5));
        productElement.querySelectorAll('[data-product-image]').forEach((element) => {
          element.src = `${variant.featured_image.src}&width=${imageWidth}`;
        });
      }
      // update product price, match element by [data-product-price-element]
      if (variant) {
        productElement.querySelectorAll('[data-product-price-element]').forEach((element) => {
          this.updatePrice(variant, element);
        });
      }
    }

    updateProductDetail(variant, available = true) {
      const productDetail = this.closest('[data-product-detail]');
      if (!productDetail) return;
      // update product variant id
      productDetail.dataset.variantId = available ? String(variant.id) : '';
      productDetail.dataset.available = available;
      // update product price, match element by [data-product-price-element]
      if (variant) {
        productDetail.querySelectorAll('[data-product-price-element]').forEach((element) => {
          this.updatePrice(variant, element);
        });
      }
      // update product buy buttons without fetch, match element by [data-product-buy-buttons-element]
      if (variant) {
        productDetail.querySelectorAll('[data-product-buy-buttons-element]').forEach((element) => {
          let inputId = element.querySelector(`[name="id"]`);
          let submitButton = element.querySelector(`[type="submit"]`);
          if (inputId && submitButton) {
            inputId.value = String(variant.id);
            // set [name="id"] disabled
            inputId.disabled = !available;
            submitButton.disabled = !available;
            // set text with data-add-to-cart-text or data-sold-out-text
            submitButton.querySelector(`span`).textContent = available
              ? window.variantStrings.addToCart
              : window.variantStrings.soldOut;
          }
        });
      }
      // updata url use push state with custom parm
      const customParm = productDetail.dataset.customParm;
      let url = `${window.location.pathname}`;
      if (customParm) {
        url = `${url}?${variant ? `variant=${variant.id}&` : ''}${customParm}`;
        window.history.replaceState({ path: url }, '', url);
      } else {
        url = `${url}?${variant ? `variant=${variant.id}` : ''}`;
        window.history.replaceState({ path: url }, '', url);
      }
      // fetch product detail then dispatchEvent
      if (!variant) return;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.dispatchEvent(
            new CustomEvent('lx-variant-selector-v1:product-detail-updated', {
              bubbles: true,
              detail: { html, variant },
            })
          );
          // update product shipping time, match element by [data-product-shipping-time-element]
          this.replaceElementWrapper(productDetail, html, '[data-product-shipping-time-element]');
          // update product properties, match element by [data-product-properties-element]
          this.replaceElementWrapper(productDetail, html, '[data-product-properties-element]');
        });
    }

    replaceElementWrapper(currentEl, nextEl, selector) {
      const $currentEl = currentEl?.querySelectorAll(selector);
      const $nextEl = nextEl?.querySelectorAll(selector);
      if (!$currentEl || !$nextEl) return false;

      $currentEl.forEach((item, index) => {
        if (!$nextEl[index]) return;
        item.innerHTML = $nextEl[index].innerHTML;
      });
      return true;
    }

    updatePrice(variant, element) {
      const currency = Shopify.currency.active;
      const language = Shopify.locale + '-' + Shopify.country;
      if (variant.price) {
        const priceFormat = (variant.price / 100).toLocaleString(language, {
          style: 'currency',
          currency: currency,
        });
        element.querySelector('[data-product-price]').textContent = priceFormat;
      }
      if (variant.compare_at_price) {
        const comparePriceFormat = (variant.compare_at_price / 100).toLocaleString(language, {
          style: 'currency',
          currency: currency,
        });
        element.querySelector('[data-product-compare-price]').textContent = comparePriceFormat;
      }
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        element.querySelector('[data-product-compare-price]').classList.remove('hidden');
      } else {
        element.querySelector('[data-product-compare-price]').classList.add('hidden');
      }
    }

    applyCurrentVariant(firstLoad = false) {
      const selectedValues = this.getSelectedOptionValues();
      const variant = this.findVariantByOptions(selectedValues);
      const productId = this.dataset.productId;

      if (!firstLoad) {
        const previousVariantId = this.dataset.productVariantId || '';
        const nextVariantId = variant ? String(variant.id) : '';
        if (previousVariantId === nextVariantId) {
          return variant;
        }
      }

      if (variant) {
        this.dataset.productVariantId = String(variant.id);
        this.dataset.variantAvailable = variant.available;
        this.updateProductInfo(variant, variant.available);
        if (!firstLoad) {
          this.updateProductDetail(variant, variant.available);
        }
      } else {
        this.dataset.variantAvailable = false;
        this.updateProductInfo(variant, false);
        if (!firstLoad) {
          this.updateProductDetail(variant, false);
        }
      }

      // get current option value text
      this.querySelectorAll('[data-option-value-text]:checked').forEach((element) => {
        const parentValueText = element
          .closest('.lx-variant-selector__option')
          .querySelector('.lx-variant-selector__option-value-text');
        if (parentValueText) {
          parentValueText.textContent = element.dataset.optionValueText;
        }
      });

      this.updateVariantStatuses();

      this.dispatchEvent(
        new CustomEvent('lx-variant-selector:change', {
          bubbles: true,
          detail: { variant, selectedValues, product: productId },
        })
      );

      return variant;
    }

    handleChange(event) {
      const target = event?.target;
      const isOptionInput =
        target instanceof HTMLInputElement &&
        target.type === 'radio' &&
        typeof target.name === 'string' &&
        target.name.startsWith('option-');

      if (isOptionInput) {
        const changedPosIndex = Number(target.name.replace('option-', '')) - 1;
        const selectedValues = this.getSelectedOptionValues();
        const currentVariant = this.findVariantByOptions(selectedValues);

        if (!currentVariant && changedPosIndex >= 0) {
          const fallbackVariant = this.findBestComposableVariant(changedPosIndex, target.value, selectedValues);
          if (fallbackVariant) {
            this.syncRadiosFromVariant(fallbackVariant);
          }
        }
      }

      this.applyCurrentVariant();
    }

    getCurrentVariant() {
      return this.findVariantByOptions(this.getSelectedOptionValues());
    }
  }

  if (!customElements.get('lx-variant-selector-v1')) {
    customElements.define('lx-variant-selector-v1', LXVariantSelectorV1);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-variant-selector"] && !Shopify.designMode) return;
  try {
    class LXVariantSelector extends HTMLElement {
    constructor() {
      super();
      this._onFormChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.variantsScript = this.form.querySelector('script[type="application/json"]');
      this.variants = this.parseVariants();

      this.form.addEventListener('change', this._onFormChange);
      this.syncRadiosFromVariantId(this.dataset.productVariantId);
      this.applyCurrentVariant();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this._onFormChange);
    }

    parseVariants() {
      if (!this.variantsScript?.textContent) return [];
      try {
        const data = JSON.parse(this.variantsScript.textContent);
        return Array.isArray(data) ? data : [];
      } catch {
        return [];
      }
    }

    /** 按 option position 顺序读取当前选中的选项值（与 JSON 里 option1/2/3 对齐） */
    getOptionGroups() {
      const root = this.querySelector('.lx-variant-selector__options');
      if (!root) return [];

      return Array.from(root.querySelectorAll('.lx-variant-selector__option')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    }

    getSelectedOptionValues() {
      return this.getOptionGroups().map((group) => {
        const input = group.querySelector('input[type="radio"]:checked');
        return input ? input.value : null;
      });
    }

    variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues) {
      if (variant[`option${posIndex + 1}`] !== candidateValue) return false;

      for (let j = 0; j < selectedValues.length; j += 1) {
        if (j === posIndex) continue;
        const sel = selectedValues[j];
        if (sel == null || sel === '') continue;
        if (variant[`option${j + 1}`] !== sel) return false;
      }

      return true;
    }

    /**
     * 当前选中值下，该维度取 candidateValue、其余维度沿用 selectedValues 时的组合状态。
     * selectedValues 中未选维度（null）不参与约束。
     * 返回 canPurchase、currentVariantNull（无变体行匹配该组合，例如仅有 Standard/Jungle Camo 而无 Large/Jungle Camo）。
     */
    hasAvailableVariantForCandidate(posIndex, candidateValue, selectedValues) {
      let hasAnyVariant = false;
      let hasAvailableVariant = false;

      for (const variant of this.variants) {
        if (!this.variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues)) continue;
        hasAnyVariant = true;
        if (variant.available === true) hasAvailableVariant = true;
      }

      return {
        currentVariantNull: !hasAnyVariant,
        canPurchase: hasAvailableVariant,
      };
    }

    /**
     * 根据当前各组选中项，更新每组内 radio。
     * - 组合在 JSON 中不存在（currentVariantNull）：始终对非当前选中项设置 disabled，忽略 canDisableInputSelection。
     * - 组合存在但售罄：仅当 data-can-disable-input-selection 为 true 时设置 disabled。
     * 已选中的项不 disabled，避免无法改选。
     */
    updateVariantStatuses() {
      if (!this.form || !this.variants.length) return;

      const selectedValues = this.getSelectedOptionValues();
      const groups = this.getOptionGroups();
      const allowDisableForSoldOut = this.dataset.canDisableInputSelection === 'true';

      groups.forEach((group, posIndex) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const { currentVariantNull, canPurchase } = this.hasAvailableVariantForCandidate(
            posIndex,
            input.value,
            selectedValues
          );

          let nativeDisabled = false;
          if (!input.checked) {
            if (currentVariantNull) {
              nativeDisabled = true;
            } else if (allowDisableForSoldOut && !canPurchase) {
              nativeDisabled = true;
            }
          }

          // input.disabled = nativeDisabled;
          input.classList.toggle('unavailable', nativeDisabled);
          input.parentElement.classList.toggle('unavailable', nativeDisabled);

          input.classList.toggle('disabled', currentVariantNull || !canPurchase);
        });
      });
    }

    findVariantByOptions(selectedValues) {
      if (!this.variants.length || selectedValues.some((v) => v == null || v === '')) {
        return null;
      }

      return (
        this.variants.find((variant) =>
          selectedValues.every((val, index) => {
            const key = `option${index + 1}`;
            return variant[key] === val;
          })
        ) || null
      );
    }

    syncRadiosFromVariant(variant) {
      if (!variant || !this.form) return;

      const groups = this.getOptionGroups();
      groups.forEach((group, index) => {
        const targetValue = variant[`option${index + 1}`];
        if (targetValue == null) return;

        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === targetValue;
        });
      });
    }

    findBestComposableVariant(changedPosIndex, changedValue, selectedValues) {
      const candidates = this.variants.filter((variant) => variant[`option${changedPosIndex + 1}`] === changedValue);
      if (!candidates.length) return null;

      const getScore = (variant) => {
        let score = variant.available ? 100 : 0;
        for (let i = 0; i < selectedValues.length; i += 1) {
          if (i === changedPosIndex) continue;
          const selected = selectedValues[i];
          if (selected && variant[`option${i + 1}`] === selected) score += 1;
        }
        return score;
      };

      let best = candidates[0];
      let bestScore = getScore(best);
      for (let i = 1; i < candidates.length; i += 1) {
        const current = candidates[i];
        const score = getScore(current);
        if (score > bestScore) {
          best = current;
          bestScore = score;
        }
      }

      return best;
    }

    syncRadiosFromVariantId(variantId) {
      if (!variantId || !this.variants.length) return;

      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      for (let i = 1; i <= 3; i += 1) {
        const val = variant[`option${i}`];
        if (val == null) continue;

        const inputs = this.form.querySelectorAll(`input[type="radio"][name="option-${i}"]`);
        inputs.forEach((input) => {
          input.checked = input.value === val;
        });
      }
    }

    updateProductInfo(variant, available = true) {
      // match element by [data-product-card] or [data-product-info]
      const productElement = this.closest('[data-product-card]') || this.closest('[data-product-info]');
      if (!productElement) return;
      //   update variant available
      productElement.dataset.variantAvailable = available;
      // update product variant id
      productElement.dataset.productVariantId = available ? String(variant.id) : '';
      // update add variant, match element by [data-add-variant]
      productElement.querySelectorAll('[data-add-variant]').forEach((element) => {
        element.dataset.addVariant = available ? String(variant.id) : '';
      });
      // update product link, match element by [data-product-link]
      productElement.querySelectorAll('[data-product-link]').forEach((element) => {
        element.href = available ? `${this.dataset.productUrl}?variant=${variant.id}` : `${this.dataset.productUrl}`;
      });
      // update product image, match element by [data-product-image]
      if (variant) {
        const imageWidth = Math.max(320, Math.min(800, window.innerWidth * 1.5));
        productElement.querySelectorAll('[data-product-image]').forEach((element) => {
          element.src = `${variant.featured_image.src}&width=${imageWidth}`;
        });
      }
      // update product price, match element by [data-product-price-element]
      if (variant) {
        productElement.querySelectorAll('[data-product-price-element]').forEach((element) => {
          if (variant.price) {
            const priceFormat = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            element.querySelector('[data-product-price]').textContent = priceFormat;
          }
          if (variant.compare_at_price) {
            const comparePriceFormat = (variant.compare_at_price / 100).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            });
            element.querySelector('[data-product-compare-price]').textContent = comparePriceFormat;
          }
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            element.querySelector('[data-product-compare-price]').classList.remove('hidden');
          } else {
            element.querySelector('[data-product-compare-price]').classList.add('hidden');
          }
        });
      }
    }

    applyCurrentVariant() {
      const selectedValues = this.getSelectedOptionValues();
      const variant = this.findVariantByOptions(selectedValues);
      const productId = this.dataset.productId;

      if (variant) {
        this.dataset.productVariantId = String(variant.id);
        this.dataset.variantAvailable = variant.available;
        this.updateProductInfo(variant, variant.available);
      } else {
        this.dataset.variantAvailable = false;
        this.updateProductInfo(variant, false);
      }

      // get current option value text
      this.querySelectorAll('[data-option-value-text]:checked').forEach((element) => {
        const parentValueText = element
          .closest('.lx-variant-selector__option')
          .querySelector('.lx-variant-selector__option-value-text');
        if (parentValueText) {
          parentValueText.textContent = element.dataset.optionValueText;
        }
      });

      this.updateVariantStatuses();

      this.dispatchEvent(
        new CustomEvent('lx-variant-selector:change', {
          bubbles: true,
          detail: { variant, selectedValues, product: productId },
        })
      );

      return variant;
    }

    handleChange(event) {
      const target = event?.target;
      const isOptionInput =
        target instanceof HTMLInputElement &&
        target.type === 'radio' &&
        typeof target.name === 'string' &&
        target.name.startsWith('option-');

      if (isOptionInput) {
        const changedPosIndex = Number(target.name.replace('option-', '')) - 1;
        const selectedValues = this.getSelectedOptionValues();
        const currentVariant = this.findVariantByOptions(selectedValues);

        if (!currentVariant && changedPosIndex >= 0) {
          const fallbackVariant = this.findBestComposableVariant(changedPosIndex, target.value, selectedValues);
          if (fallbackVariant) {
            this.syncRadiosFromVariant(fallbackVariant);
          }
        }
      }

      this.applyCurrentVariant();
    }

    getCurrentVariant() {
      return this.findVariantByOptions(this.getSelectedOptionValues());
    }
  }

  if (!customElements.get('lx-variant-selector')) {
    customElements.define('lx-variant-selector', LXVariantSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snippet-trustpilot"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {});
  } catch(e) { console.error(e); }
})();

})();
